export enum DimensionType {
  Number = 0,
  String = 1,
  Date = 2
}
